import {Link} from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router-dom';
import {useRef} from 'react';
import {useState, useEffect} from 'react';
import Badge from './assets/badge';
import InstaLogo from './InstaLogo';

function NavigationBar(props) {

    const navigate = useNavigate();
    const location = useLocation();

    const scrollOrNavigate = (ref) => {
        if (location.pathname === '/') {
          ref.current?.scrollIntoView({ behavior: 'smooth' });
        } else {
          
          setTimeout(() => {

            ref.current?.scrollIntoView({ behavior: 'smooth' });
          }, 200); // delay to ensure the section is mounted
          
        }
      };

    // const scrollToShop = () => {
    //     if (props.shopRef.current) {
    //         props.shopRef.current.scrollIntoView({behavior: 'smooth'});
    //     }
    // };

    // const scrollToVideos = () => {
    //     if (props.videosRef.current) {
    //         props.videosRef.current.scrollIntoView({behavior: 'smooth'});
    //     }
    // };

    // const scrollToContact = () => {
    //     if (props.contactRef.current) {
    //         props.contactRef.current.scrollIntoView({behavior: 'smooth'});
    //     }
    // };

    return (
        <div style={{
            width: '100%'
          }}>
            

              
              {/* <div style={{
                width: '70%',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                columnGap: '15%',
                // borderBottom: '1px solid black'

              }}>
              <Link to='/shop' className='link'>Shop</Link>
              <Link to='/contact' className='link'>Contact</Link>
              <Link to='/videos' className='link'>Videos</Link>
              <InstaLogo/>
              </div> */}

              <div style={{
                backgroundColor: '#fbfbf3',
                // borderBottom: '1px solid black',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                columnGap: '15%',
                padding: '1rem 0',

              }}>
              <Link to='/' className='link' onClick={() => scrollOrNavigate(props.shopRef)}>Shop</Link>
              <Link to='/' className='link' onClick={() => scrollOrNavigate(props.videosRef)}>Videos</Link>
              <Link to='/' className='link' onClick={() => scrollOrNavigate(props.contactRef)}>Contact</Link>
              <InstaLogo/>
              </div>

              
              </div>
              
    )
}

export default NavigationBar;